import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";
import TermsAndConditions from "../legal/TermsAndConditions";
import PrivacyPolicy from "../legal/PrivacyPolicy";
import UserConsentAgreement from "../legal/UserConsentAgreement";

function Footer({ onPricingClick, onContactClick }) {
  const [legalModalView, setLegalModalView] = useState(null); // null, "terms", "privacy", or "consent"

  const handleLinkClick = (e, section) => {
    e.preventDefault();

    // Adjust scroll position by the height of the header
    const headerElement = document.querySelector(".landing-header");
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;

    switch (section) {
      case "features":
        const featuresSection = document.querySelector(".landing-main20");
        if (featuresSection) {
          const topPosition = featuresSection.offsetTop - headerHeight;
          window.scrollTo({ top: topPosition, behavior: "smooth" });
        }
        break;
      case "pricing":
        if (onPricingClick) {
          onPricingClick();
        }
        break;
      case "contact":
        if (onContactClick) {
          onContactClick();
        }
        break;
      default:
        break;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section-about">
          <h4>About KinShield™</h4>
          <p>
            KinShield™ empowers families to recognize and defend against cyber
            threats through real-time analysis of emails, texts, and social
            media messages, combined with realistic, personalized simulations.
            Practice identifying phishing, scams, and social engineering attacks
            in a safe environment while protecting your loved ones from
            real-world digital dangers.
          </p>
          <div className="footer-business-info">
            <p className="footer-business-name">
              <strong>Reliable IT Associates, LLC</strong>
            </p>
            <p className="footer-business-address">Maryland, USA</p>
            <p className="footer-business-contact">
              Email:{" "}
              <a href="mailto:info@kinprotect.com">info@kinprotect.com</a>
              <br />
              Phone: 301-237-7843
            </p>
          </div>
        </div>
        <div className="footer-section-wrapper">
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a
                  href="#features"
                  onClick={(e) => handleLinkClick(e, "features")}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  onClick={(e) => handleLinkClick(e, "pricing")}
                >
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => handleLinkClick(e, "contact")}
                >
                  Contact Us
                </a>
              </li>
              <li>
                <button
                  className="footer-legal-link"
                  onClick={() => setLegalModalView("terms")}
                >
                  Terms & Conditions
                </button>
              </li>
              <li>
                <button
                  className="footer-legal-link"
                  onClick={() => setLegalModalView("privacy")}
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  className="footer-legal-link"
                  onClick={() => setLegalModalView("consent")}
                >
                  User Consent Agreement
                </button>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Stay Informed</h4>
            <ul>
              <li>
                <a
                  href="https://www.ftc.gov"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Federal Trade Commission (FTC)
                </a>
              </li>
              <li>
                <a
                  href="https://www.aarp.org/money/scams-fraud/about-fraud-watch-network/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AARP Fraud Watch Network
                </a>
              </li>
              <li>
                <a
                  href="/docs/TelltaleSigns.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Phishing Awareness Guide (PDF)
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61586803455465"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer">
                X
              </a>
              <a
                href="https://linkedin.com/company/kinshield-app"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-company-info">
          <p className="footer-company-name">
            KinShield™ is a product of{" "}
            <a
              href="https://shield.kinprotect.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-company-link"
            >
              Reliable IT Associates, LLC
            </a>
          </p>
          <p className="footer-copyright">
            &copy; 2024 Reliable IT Associates, LLC. All rights reserved.
          </p>
        </div>
      </div>

      {/* Legal Modal */}
      {legalModalView && (
        <div
          className="footer-legal-modal"
          onClick={() => setLegalModalView(null)}
        >
          <div
            className="footer-legal-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="back-to-footer-button"
              onClick={() => setLegalModalView(null)}
            >
              Close
            </button>
            <div className="footer-legal-content-wrapper">
              {legalModalView === "terms" && <TermsAndConditions />}
              {legalModalView === "privacy" && <PrivacyPolicy />}
              {legalModalView === "consent" && <UserConsentAgreement />}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
